import type { ComponentType } from "react";

import type { PreSubmitStepId, StepProps } from "../types";
import { AboutStep } from "./about";
import { AccountStep } from "./account";
import { BuildingStep } from "./building";
import { ConcernsStep } from "./concerns";
import { ExamDateStep } from "./exam-date";
import { HookStep } from "./hook";
import { HowItWorksStep } from "./how-it-works";
import { PaceStep } from "./pace";
import { PlanStep } from "./plan";
import { ProfessionStep } from "./profession";
import { ReferralStep } from "./referral";
import { ReframeStep } from "./reframe";
import { RoleStep } from "./role";
import { TrackStep } from "./track";

/** Step id → screen. A Record over every pre-submit id, so adding a step to
 *  flow.ts fails to compile until it has a screen. */
export const STEP_COMPONENTS: Record<PreSubmitStepId, ComponentType<StepProps>> = {
  hook: HookStep,
  role: RoleStep,
  profession: ProfessionStep,
  track: TrackStep,
  examDate: ExamDateStep,
  concerns: ConcernsStep,
  reframe: ReframeStep,
  howItWorks: HowItWorksStep,
  referral: ReferralStep,
  pace: PaceStep,
  building: BuildingStep,
  plan: PlanStep,
  account: AccountStep,
  about: AboutStep,
};
